<template>
  <nav class="breadcrumb" aria-label="Breadcrumb">
    <a href="/">Home</a>
    <span>/</span>
    <a href="/gbwhatsapp-blog/">Blog</a>
    <span>/</span>
    <span>{{ currentTitle }}</span>
  </nav>
</template>

<script>
export default {
  name: 'Breadcrumb',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
  computed: {
    currentTitle() {
      return this.title || this.$route.meta.title || 'Article';
    },
  },
};
</script>

<style scoped>
.breadcrumb {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0 0 24px;
  color: #60736b;
  font-size: 14px;
  line-height: 1.5;
  text-align: left;
}

.breadcrumb a {
  color: #128c7e;
  text-decoration: none;
  font-weight: 600;
}

.breadcrumb a:hover {
  text-decoration: underline;
}

.breadcrumb span:last-child {
  color: #2f3b45;
}
</style>
